import { useCallback } from 'react';
import { useAppSelector } from 'slices/store';
import { usersSelector } from 'slices/user.slice';
import { Select, type SelectProps } from '@timeedit/ui-components/antd';
import ExternalUserSelectComponent from './ExternalUserSelectComponent';

type TUserSelectComponentProps = {
  onChange: (prop: string, value: string) => void;
  isMultiSelect: boolean;
  value: any;
  propName: string;
  label: string;
  tooltip?: string;
};

const UserSelectComponent = ({
  isMultiSelect,
  onChange,
  propName,
  ...props
}: TUserSelectComponentProps) => {
  const users = useAppSelector(usersSelector);

  const filterOption = useCallback<
    Exclude<SelectProps['filterOption'], boolean>
  >(
    (input, option: any) =>
      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    []
  );

  const mode = isMultiSelect ? 'multiple' : undefined;

  const onPerformChange = useCallback(
    (value: string) => {
      onChange(propName, value);
    },
    [onChange, propName]
  );

  return (
    <ExternalUserSelectComponent
      filterOption={filterOption}
      mode={mode}
      onChange={onPerformChange}
      {...props}
    >
      {Object.entries(users).map(([key, value]) => (
        <Select.Option value={value.id} key={key}>
          {value.email}
        </Select.Option>
      ))}
    </ExternalUserSelectComponent>
  );
};

export default UserSelectComponent;
